module.exports = __webpack_public_path__ + "static/media/slack-webhook.edb7d6b2.png";